<template>
  <div class="page-wecom-seminar-divide"></div>
</template>
<script>
import { getRequest } from 'utils/string';
import { postOauth, getEId } from 'utils/wecom/seminar';
export default {
  name: 'Divide',
  computed: {
    userId() {
      return getRequest()?.user_id || '';
    },
    pageOrigin() {
      return window.location.origin;
    },
    middleUrl() {
      return `/wecom/seminar/middle/status/${this.userId}`;
    },
    returnUrl() {
      return `${this.pageOrigin}${this.middleUrl}`;
    },
    failUrl() {
      return `/wecom/seminar/error/user-1/${this.userId}`;
    }
  },
  created() {
    this.$loading.show();
    getEId().then(res => {
      if (res?.data) {
        this.$location(`/wecom/seminar/add/${this.userId}/service`);
      } else {
        postOauth(this.returnUrl, this.failUrl);
      }
    });
    this.$loading.hide();
  }
};
</script>
